import { IClientConfig } from '@front/interfaces/client-config.interface';
import { gskConfig } from './gsk.config';

export const ekiGskConfig: IClientConfig = {
  ...gskConfig,
  pooledModeling: false
};
